import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Information = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Information_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34 11.461V12h3.355v-.539h-.132c-.125 0-.253-.015-.385-.044a.598.598 0 0 1-.32-.209c-.08-.11-.12-.271-.12-.484v-4.62H6.384v.539h.099c.125 0 .25.015.374.044a.59.59 0 0 1 .319.198c.088.095.132.246.132.451v3.41c0 .205-.044.36-.132.462a.598.598 0 0 1-.32.209 1.63 1.63 0 0 1-.373.044H6.34ZM7.385 4.894a.964.964 0 0 0 .583.176.964.964 0 0 0 .583-.176c.161-.117.242-.308.242-.572 0-.271-.08-.462-.242-.572a.946.946 0 0 0-.572-.176.983.983 0 0 0-.594.176c-.154.11-.231.3-.231.572 0 .264.077.455.23.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1 0A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Information_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Information;